import { store } from '@/src/stores/store'

export function vibrate(pattern: number | number[]) {
    if (typeof navigator === 'undefined') return
    if (!('vibrate' in navigator)) return
    if (!store.vibrationEnabled) return

    navigator.vibrate(pattern)
}